import EnrollmentAcknowledgement from "../../enrollmentAcknowledgement/EnrollmentAcknowledgement";
import { useState, useEffect, useContext, useCallback, useMemo } from "react";
import { VEBPlanAcknowledgementProps } from "../../../../../types/components/enrollmentProps.types";
import { VEBEnrollmentSchema } from "../../../../../types/enrollment.types";
import { AuthContext, ThemeContext } from "../../../../../contexts";
import { Paper, Grid, Button } from "@mui/material";
import { useHistory, useLocation } from "react-router-dom";
import { trackPromise } from "react-promise-tracker";
import { api } from "../../../../../utils/api";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../../../app/store";
import { fetchActiveVEBPlans } from "../../../../../features/VEBPlans/VEBPlansThunks";
import { getVEBEnrollmentInitData } from "../../../../../utils/api/pages/enrollmentInit";

const VEBPlanAcknowledgement = ({
	VEBEnrollments,
	VEBOpenEnrollment,
	VEBPlanName,
	handleStackEnrollmentClick
}: VEBPlanAcknowledgementProps & any): JSX.Element => {
	const { theme } = useContext(ThemeContext);
	const [VEBEnrollment, setVEBEnrollment] = useState<VEBEnrollmentSchema>();
	const { member } = useContext(AuthContext);
	const location = useLocation();
	const history = useHistory();
	const [planCode, setPlanCode] = useState<string>();
	const [VEBOpenEnrollmentId, setVEBOpenEnrollmentId] = useState<string>();

	const [isStackedPlan, setIsStackedPlan] = useState<boolean>(false);
	const urlSearchParams: URLSearchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
	const isYearlyOpen = VEBOpenEnrollment[0]?.open_enrollment?.type;
	const dispatch = useDispatch<AppDispatch>();

	useEffect(() => {
		// Dispatch RTK thunk to populate currentPlans
		dispatch(fetchActiveVEBPlans(member?.group_number));
	}, [dispatch]);

	const findPlanEnrollment = useCallback(() => {
		if (!member) return;

		const enrollment = VEBEnrollments.find(
			(enrollment: any) =>
				enrollment.member_SSN === member.SSN &&
				enrollment.insured_SSN === member.SSN &&
				(enrollment.plan_name === VEBPlanName || enrollment.base_plan_name === VEBPlanName)
		);

		if (enrollment) {
			setVEBEnrollment({ ...enrollment });
		}
	}, [VEBEnrollments, member, VEBPlanName]);

	const getVEBPlanCode = useCallback(
		(VEBOpenEnrollment: any[]) => {
			let _planCode, _VEBOpenEnrollmentId;
			for (let idx = 0; idx < VEBOpenEnrollment.length; idx++) {
				let planName = VEBOpenEnrollment[idx].open_enrollment.veb_plan_name;
				const planCode = VEBOpenEnrollment[idx].open_enrollment.veb_plan_code;
				const VEBOpenEnrollmentId = VEBOpenEnrollment[idx].VEB_open_enrollment_id;

				planName = planName == "Group Life Indemnity" ? "Group Limited Indemnity" : planName;
				if (planName === VEBPlanName) {
					_planCode = planCode;
					_VEBOpenEnrollmentId = VEBOpenEnrollmentId;
				}
			}

			setPlanCode(_planCode);
			setVEBOpenEnrollmentId(_VEBOpenEnrollmentId);
		},
		[VEBPlanName]
	);

	const handleEnrollAgainButtonClick = useCallback(() => {
		const step = urlSearchParams.get("step");
		history.push(`?step=${step}&stage=1`);
	}, [history, urlSearchParams]);
	useEffect(() => {
		findPlanEnrollment();
	}, [findPlanEnrollment]);

	const getBenefits = useCallback(async () => {
		if (member) {
			const getBenefitsQuery: any = {
				base_plan_name: VEBPlanName,
				// group_number: member.group_number,
				insured_SSN: member.SSN
				// member_SSN: member.SSN
			};
			const benefitsResponse: any = await trackPromise(
				api.enrollment.getActiveVEBEnrollmentWithRider(getBenefitsQuery)
			);

			if (benefitsResponse.isStacked == true) {
				setIsStackedPlan(true);
			} else {
				setIsStackedPlan(false);
			}
		}

		// console.log("bbb", benefitsResponse);
	}, [VEBPlanName, member]);

	useEffect(() => {
		if (!VEBOpenEnrollment || VEBOpenEnrollment.length === 0) return;
		getVEBPlanCode(VEBOpenEnrollment);
		getBenefits();
	}, [VEBOpenEnrollment, getVEBPlanCode, member]);

	return (
		<div className="paper-form-container">
			<Paper className="theme-border-radius paper-container" elevation={1}>
				{VEBOpenEnrollment && VEBEnrollment ? (
					<EnrollmentAcknowledgement
						idCardAccessPointRequired={true}
						dependentChangePointRequired={true}
						carrierPhoneNo={"(555) 555-1234"}
						carrierWebsite={"brookshirebrothers.com"}
						planDocument={""}
						planName={VEBPlanName === "Family Protection" ? "Term Life To Age 121" : VEBPlanName}
						addDependentLink={"/home/add-family-member"}
						planCode={VEBEnrollment.plan_code}
						removeDependentLink={""}
						status={VEBEnrollment.enrollment_status}
						isYearlyOpen={isYearlyOpen}
					/>
				) : null}
				<div className="theme-plan-section-margin" />
				{VEBOpenEnrollment && VEBOpenEnrollment.length > 0 ? (
					<>
						{!isStackedPlan && (
							<Grid container>
								<Grid item xl={4} lg={4} xs={12} md={12} sm={12}></Grid>
								<Grid item xl={4} lg={4} xs={12} md={12} sm={12}>
									<Button
										style={{
											backgroundColor: theme.button.background_color,
											color: theme.button.color,
											width: "100%"
										}}
										onClick={handleEnrollAgainButtonClick}
									>
										Enroll again
									</Button>
								</Grid>
								<Grid item xl={4} lg={4} xs={12} md={12} sm={12}></Grid>
							</Grid>
						)}
						{isStackedPlan && handleStackEnrollmentClick && (
							<Grid container>
								<Grid item xl={4} lg={4} xs={12} md={12} sm={12}></Grid>
								<Grid item xl={4} lg={4} xs={12} md={12} sm={12}>
									<Button
										style={{
											backgroundColor: theme.button.background_color,
											color: theme.button.color,
											width: "100%"
										}}
										onClick={handleStackEnrollmentClick}
									>
										Stack again
									</Button>
								</Grid>
								<Grid item xl={4} lg={4} xs={12} md={12} sm={12}></Grid>
							</Grid>
						)}
					</>
				) : null}
			</Paper>
		</div>
	);
};

export default VEBPlanAcknowledgement;
